export default "__VITE_ASSET__V5f_ic6r__"